import { render, staticRenderFns } from "./template11.vue?vue&type=template&id=17c4ffb6&scoped=true"
import script from "./template11.vue?vue&type=script&lang=js"
export * from "./template11.vue?vue&type=script&lang=js"
import style0 from "./template11.vue?vue&type=style&index=0&id=17c4ffb6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17c4ffb6",
  null
  
)

export default component.exports